import React from 'react'
import PanelContainer from 'containers/panel/reseller/panel-container'

const MainPage = () => {
  return (
    <PanelContainer />
  )
}

export default MainPage